import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { en } from "./en";
import { el } from "./el";
import { ru } from "./ru";

export const dicts = { en, el, ru };
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const isPreview = () => localStorage.getItem("ha-preview") === "1" && !!localStorage.getItem("ha-token");
export const exitPreview = () => {
  localStorage.removeItem("ha-preview");
  window.location.reload();
};
export const enterPreview = () => {
  localStorage.setItem("ha-preview", "1");
};

export const deepMerge = (base, over) => {
  if (over === undefined || over === null) return base;
  if (typeof base !== "object" || base === null || Array.isArray(base) || typeof over !== "object" || Array.isArray(over)) return over;
  const out = { ...base };
  for (const k of Object.keys(over)) out[k] = deepMerge(base[k], over[k]);
  return out;
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("ha-lang");
    return dicts[saved] ? saved : "en";
  });
  const [overrides, setOverrides] = useState({});
  const [images, setImages] = useState({});
  const preview = isPreview();

  useEffect(() => {
    localStorage.setItem("ha-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    const cfg = preview
      ? { params: { mode: "draft" }, headers: { Authorization: `Bearer ${localStorage.getItem("ha-token")}` } }
      : {};
    axios.get(`${API}/content/${lang}`, cfg).then((r) => setOverrides(r.data || {})).catch(() => setOverrides({}));
  }, [lang, preview]);

  useEffect(() => {
    axios.get(`${API}/images`).then((r) => {
      const map = {};
      (r.data || []).forEach((i) => {
        map[i.key] = i.url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${i.url}` : i.url;
      });
      setImages(map);
    }).catch(() => {});
  }, []);

  const t = deepMerge(dicts[lang], overrides);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, images, preview }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
